import { Component, Injectable, OnInit } from '@angular/core';
import { Menu } from '../../models/Menu';
import { MenuService } from '../../services/MenuService';

@Component({
    selector: 'top-menu',
    template: require('./TopMenuComponent.html'),
    styles: [require('./TopMenuComponent.sass')],
    providers: [
        MenuService
    ]
})

export class TopMenuComponent implements OnInit {
    private menuList: Menu[];
    private socialMenuList: Menu[];
    private currentLang: string;
    
    constructor(private menuService: MenuService){ }
    
    ngOnInit () {
        /** TO DO 
         * Get current language from cookie/session
         * If no language data from it, set default language as English
         */
        this.currentLang = 'en';
        // Get Top Menu List
        this.menuList = this.menuService.getMenuList('top');
        // Get Social Connect Menu List
        this.socialMenuList = this.menuService.getMenuList('social-top');
    }
}


// WEBPACK FOOTER //
// ./src/common/modules/core/components/top-menu/TopMenuComponent.ts